import {useState} from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {Row, Col} from 'react-bootstrap';
import withAlerts from '../../lib/withAlerts';
import {FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faPlus} from '@fortawesome/pro-light-svg-icons';
import {compose} from '../../lib/compose';
import Modal from 'react-bootstrap/Modal';
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import { gql } from "@apollo/client";
import { useLazyQuery, useQuery } from "@apollo/client/react";
import WhitelistConfirmModal from './confirmWhitelistModal';
import {useWhitelistMutations} from './whitelistMutations';
import cx from 'classnames';

export const CreateWhitelistModal = (props) => {
  const [show, setShow] = useState(false);
  const { register, control, trigger, handleSubmit, reset, setFocus, watch, formState: {errors} } = useForm({
    defaultValues: {
      ssids: [{ 
        ssid: "",
        site_account_id: "44444444-4444-4444-4444-444444444444"
       }]
    },
    mode: 'onBlur'
  });

  const dirtyForm = Object.keys(errors)?.length !== 0;

  const uniqueSsid = (fields) => {
    const ssidSet = new Set(fields.map((field) => field.ssid));
    return ssidSet.size === fields.length ? true : 'Duplicate ssid found';
  };
  
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "ssids",
    rules: {
      validate: uniqueSsid
    }
  });

  const {create} = useWhitelistMutations();
  const {success, error} = props.alerts;
  const {disabled} = props;
  const [duplicateName, setDuplicateName] = useState(false);
  const [getWhitelistNames] = useLazyQuery(WHITELISTS);
  const {data: customerAccounts} = useQuery(CUSTOMER_ACCOUNTS);

  const accounts = customerAccounts?.CustomerAccounts?.result || [];
  
  const handleShow = () => {
    reset();
    setDuplicateName(false);
    setShow(true);
  }
  const handleClose = () =>  {
    reset();
    setDuplicateName(false);
    setShow(false);
  }

  const nameCheck = async (name) => {
    
    if(name !== '') {
      const check = await getWhitelistNames({
        variables: {
          filters: {
            field: "name",
            value: name
          }
        }
      })

      if(check?.data?.Whitelists) {
        setDuplicateName(true);
        setFocus('name')
        return;
      } else {
        setDuplicateName(false);  
      }
    }
  }
  
  const handleWhitelist = async (formData) => {
    const name = formData?.name || "";

    const filtered = JSON.stringify(formData?.ssids?.filter((pair) => {
        return pair.ssid != null && pair.ssid != "";
    }).map((el) => el));

    const whitelistInput = {
      name: name,
      SSIDs: filtered
    };

    const createWhitelist = await create({variables: {whitelist: whitelistInput}});
    if(createWhitelist.errors) {
      error({msg: "Wi-Fi SSID List creation failed."});

    } else {
      success({msg: `Wi-Fi SSID List created.`});
      reset();
      handleClose();
    }
  }

  const max8 = watch("ssids").length === 8;
  return (
    <>
      <Button data-testid="" className="ms-3" onClick={handleShow} disabled={disabled}>Create List</Button>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        show={show}
        onHide={handleClose}
        animation={false}
        className="modal-white"
      >
        <Form className="mb-3" onSubmit={handleSubmit(handleWhitelist)}>
          <Modal.Header closeButton>
            <Modal.Title>Create List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-form-white">
              <Row>
                <Col sm="6">
                  <Form.Group className="mb-5">
                    <Form.Label>List Name</Form.Label>
                    <Form.Control
                    {...register("name", {
                      onBlur: (e) => nameCheck(e.target.value),
                      required: true,
                      maxLength: {
                        value: 50,
                        message: "Length of List Name exceeds 50 characters."
                      }
                    })}
                    type="text"
                    placeholder="Name"
                    className={cx({'error-input': duplicateName || errors.name })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  {fields.map((item, i) => {
                    return (
                      
                      <Row className="mb-3" key={item.id}>
                        <Col sm="6">
                          <Form.Label>SSID</Form.Label>
                          <Form.Group className="ssid-input mb-3" key={`whitelist_${i}`}>
                            <Form.Control
                              {...register(`ssids.${i}.ssid`, {
                                onBlur: () => trigger('ssids')
                              })}
                              id={item?.id}
                              type="text"
                              placeholder="SSID..."
                              control={control}
                              className={cx({'error-input': errors?.ssids})}
                              />
                          </Form.Group>
                        </Col>
                        <Col sm="6">
                          <Row className="align-items-center">
                            <Col sm="11">
                              <Form.Label>Site Description</Form.Label>
                              <Form.Select
                                {...register(`ssids.${i}.site_account_id`)}
                                control={control}>
                                { accounts.map(({id, description}) => (
                                  <option key={id} value={id}>{description}</option>
                                  ))}
                              </Form.Select>
                            </Col>
                            <Col sm="1">
                            <Form.Label></Form.Label>
                              <span
                              className="privoro-gray pointer d-block mt-2"
                              onClick={() => {remove(i)}}
                              onKeyDown={() => {remove(i)}}>
                            <FontAwesomeIcon icon={faXmark} size="sm" /></span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )
                  })}
                </Col>
              </Row>

              {!max8 && <Row className="mb-3">
                <Col>
                  <span
                    className="privoro-gray"
                    onClick={() => {append({ssid: ""})}}
                    onKeyDown={() => {append({ssid: ""})}}>
                      <FontAwesomeIcon icon={faPlus} size="sm" /> <span className="link-span">Add SSID</span></span>
                </Col>
              </Row>}
            </div>

            {errors.ssids &&
              <div className="d-grid gap-2">
                <strong className="privoro-black">SSIDs must be unique.<br/></strong>
              </div>
            }
            
            {errors.name && errors.name.type === "required" &&
              <div className="d-grid gap-2">
                <strong className="privoro-black">List name is required.<br/></strong>
              </div>
            }
            {errors?.name && errors.name.type === "maxLength" &&
              <div className="d-grid gap-2">
                <strong className="privoro-black">{errors?.name?.message}<br/></strong>
              </div>
            }

            {duplicateName &&
              <div className="d-grid gap-2">
                <strong className="privoro-black">List name already exists.<br/></strong>
              </div>
            }

          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end">
              <Button onClick={handleClose} variant="secondary">Cancel</Button> 
              <Button type="submit" className="ms-2" disabled={dirtyForm || disabled}>Submit</Button> 
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

CreateWhitelistModal.propTypes = {
  alerts: PropTypes.shape({
    error: PropTypes.func,
    success: PropTypes.func
  })
}

const WHITELISTS = gql`
  query getWhitelists($filters: GenericFilters!) {
    Whitelists(filters: $filters) {
      result {
        name
      }
    }
  }
`;

const CUSTOMER_ACCOUNTS = gql`
  query getSiteLocations($filters: GenericFilters) {
    CustomerAccounts(filters: $filters) {
      result {
        id
        name
        description
        root
        parent
      }
    }
  }
`;

export default compose(
  withAlerts,
)(CreateWhitelistModal);
